// Init
import Vue from "vue";
import Router from "vue-router";
import App from "../App.vue";

//Import defaul layaout
import layout from "../layout";
import layout2 from "../layout-2";
import accueil from "../pages/accueil/accueil.vue";

// Import Modules routes
import paymentRoutes from './payment.js';
import movmentRoutes from './movment.js';
import serviceRoutes from './service.js';

import assuranceRoutes from './assurance.js';
import patientRoutes from './patient.js';
import stockRoutes from './stock.js';
import hospitalizationRoutes from './hospitalization.js';
import userRoutes from './user.js';
import pharmacyRoutes from './pharmacy.js';
import grhRoutes from './grh.js';
import rapport_statistiqueRoutes from './rapport_statistique.js';
import rembourse_recouvreRoutes from './rembourse_recouvre.js';

// base_url....
base: "/",

    Vue.use(Router);

const router = new Router({

    linkExactActiveClass: "active",
    scrollBehavior: () => ({ y: 0 }),
    mode: "history",

    routes: [

        {
            path: "/",
            component: accueil,
        },

        {
            path: "/auth-pages",
            component: {
                render(c) {
                    return c("router-view");
                },
            },
            children: [{
                    path: "login",
                    name: "login",
                    component: () =>
                        import ("@/pages/authentification/auth-pages/login"),
                },
                {
                    path: "register",
                    name: "register",
                    component: () =>
                        import ("@/pages/authentification/auth-pages/register"),
                },
                {
                    path: "reset",
                    name: "reset",
                    component: () =>
                        import ("@/pages/authentification/auth-pages/reset-password"),
                },
                {
                    path: "forget-password",
                    name: "forget-password",
                    component: () =>
                        import ("@/pages/authentification/auth-pages/forget-password"),
                },
                {
                    path: "forget-password-confirm",
                    name: "forget-password-confirm",
                    component: () =>
                        import ("@/pages/authentification/auth-pages/forget-password-confirm"),
                },
            ],
        },

        {
            path: "/home",
            component: layout2,
            children: [{
                path: "",
                name: "home",
                component: () =>
                    import ("@/pages/dashboard/home"),
            }, ],
        },


        //Movement routes
        ...movmentRoutes,
        ...serviceRoutes,


        //Movement routes
        ...movmentRoutes,
        //Stock routes
        ...stockRoutes,
        //Hospitalization routes
        ...hospitalizationRoutes,
        //Payment routes
        ...paymentRoutes,
        // Pharmacy Routes
        ...pharmacyRoutes,



        //Assurance
        ...assuranceRoutes,

        // Patient
        ...patientRoutes,

        ...userRoutes,
        ...grhRoutes,
        ...rapport_statistiqueRoutes,

        // remboursement et recouvrement
        ...rembourse_recouvreRoutes

    ],
});


//Login controls routes
router.beforeEach((to, from, next) => {
    const publicPages = [
        "/",
        "/auth-pages/login",
        "/auth-pages/forget-password",
        "/auth-pages/reset",
    ];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem("user");

    if (authRequired && !loggedIn) {
        next("/auth-pages/login");
    } else {
        next();
    }
});

export default router;
